$(document).ready(function () {
    let timer = null;
    const $input = $('#buscador_monedero');
    const $resultados = $('#resultados_monedero');

    $("#table-premier-customer").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': '/get.premier.customers',
        'columns': [
            {data: 'name'},
            {data: 'phone'},
        ],
        order: [[1,'desc']],
        "language": {
            "url": window.location.origin + "/json/Spanish.json"
        },
    })

    $('#add-customer').on('click', function (e) {
        e.preventDefault();
        $('#modal-add-premier-customer').modal('show');
    })

    $("#form-add-premier-customer").on('submit', function (e) {
        e.preventDefault();
        let data = new FormData(this);
        clearSpan();
        $.ajax({
            url: '/add-premier-customer',
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {

                if (response.success) {
                    setTimeout(function () {
                        $('#modal-add-premier-customer').modal('hide');
                        alertSuccess(response.msg)
                        $("#table-premier-customer").DataTable().ajax.reload()
                    }, 1000)
                    return;
                }
                alertError(response.msg)
            }, error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    console.log(index,value);
                    $("#item-error-" + index).html(value)
                });
            }

        });

    })

    function buscar(query) {
        if (query.length < 2) {
            $resultados.hide().empty();
            return;
        }

        $.ajax({
            url: "/monederos.search",
            method: 'GET',
            data: { q: query },
            success: function (data) {
                $resultados.empty();
                if (data.length === 0) {
                    $resultados.append('<div class="list-group-item disabled">Sin resultados</div>');
                } else {
                    data.forEach(function (cliente) {
                        $resultados.append(`
                            <a href="#" class="list-group-item list-group-item-action item-monedero"
                               data-id="${cliente.id}"
                               data-name="${cliente.name}"
                               data-num_card="${cliente.num_card}"
                               data-phone="${cliente.phone}"
                               data-email="${cliente.email}"
                                <strong>${cliente.name}</strong> — Monedero: ${cliente.num_card}
                            </a>
                        `);
                    });
                }
                $resultados.show();
            },
            error: function () {
                $resultados.html('<div class="list-group-item text-danger">Error al buscar</div>').show();
            }
        });
    }
    $input.on('keyup', function () {
        clearTimeout(timer);
        const query = $(this).val().trim();
        timer = setTimeout(function () { buscar(query); }, 400);
    });

    $('#btn_buscar').on('click', function (e) {
        e.preventDefault();
        buscar($input.val().trim());
    });

    $(document).on('click', '.item-monedero', function (e) {
        e.preventDefault();
        const $el = $(this);

        $('#cs_id').val($el.data('id'));
        $('#cs_nombre').text($el.data('name'));
        $('#cs_numero').text($el.data('num_card'));
        $('#cs_phone').text($el.data('phone'));
        $('#cs_email').text($el.data('email'));

        $('#cliente_seleccionado').show();
        $resultados.hide().empty();
        $input.val($el.data('name'));
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('#buscador_monedero, #resultados_monedero').length) {
            $resultados.hide();
        }
    });

    $('#btn_continuar').on('click', function () {
        const id = $('#cs_id').val();
        let data = new FormData();
        data.append('cliente_id', id);

        $.ajax({
            url: "/monederos.select",
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (response) {

                if(response.success) {
                    alertSuccess(response.msg);
                    $("#table-premier-customer").DataTable().ajax.reload()
                    limpiarSeleccion();
                }
            },
            error: function (xhr) {
                console.error(xhr.responseText);
            }
        });
    });

    function limpiarSeleccion() {

        $('#buscador_monedero').val('');

        $('#cs_id').val('');
        $('#cs_name').text('');
        $('#cs_num_card').text('');
        $('#cs_phone').text('');
        $('#cs_email').text('');

        $('#cliente_seleccionado').hide();

        $('#resultados_monedero').hide().empty();
    }

    function clearSpan() {
        $("#item-error-name").html('')
        $("#item-error-phone").html('')
        $("#item-error-email").html('')
        $("#item-error-num_card").html('')
    }
})
